const path = 'redux/program';
export const PROGRAMS_LOADED = `${path}/PROGRAMS_LOADED`;
export const PROGRAM_LOADED = `${path}/PROGRAM_LOADED`;

